import { ReactNode } from 'react'
import { Notification as AlliumNotification } from '@telus-uds/components-web'
import { SpacerProps } from '../Spacer/Spacer'
import { renderSpacer } from 'src/siteBuilder/utils/renderSpacer'

export type NotificationProps = {
  content: ReactNode
  style: 'default' | 'success' | 'warning' | 'error'
  dismissible?: boolean
  system?: boolean
  spacer?: SpacerProps
  textPosition?: 'left' | 'center' | 'right'
}

const Notification = ({ content, style, dismissible, system, spacer, textPosition = 'left' }: NotificationProps) => {
  // this is to convert the textPosition prop to the justifyContent token
  const setTextPosition = textPosition === 'left' ? 'flex-start' : textPosition === 'center' ? 'center' : 'flex-end'
  return (
    <div data-testid="notification-testid">
      {renderSpacer(spacer)}
      <AlliumNotification
        variant={{ style }}
        dismissible={dismissible}
        system={system}
        tokens={{ justifyContent: setTextPosition }}
      >
        {content}
      </AlliumNotification>
    </div>
  )
}

export default Notification
